<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="プライベートサイト設定参照(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-3">
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn v-permission.config color="primary" @click="toChange"
                  >変更</v-btn
                >
              </v-col>
            </v-row>
            <div class="my-2">
              <v-row>
                <v-col>
                  <app-label-group label="回線番号" :value="enumber" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <app-label-group
                    label="サイト名"
                    :value="siteList.siteName"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <app-label-group
                    label="VLAN"
                    :value="
                      siteList.vlanIdType === 'UNTAG'
                        ? 'Untag'
                        : siteList.vlanId
                    "
                  />
                </v-col>
              </v-row>
            </div>
            <app-table
              :fields="privateData.fields"
              :items="privateData.items"
              primary-key="ipAddressId"
              :tr-class="() => undefined"
              density="compact"
            >
              <template #cell(ipAddressName)="data">
                {{ data.value ? data.value : "-" }}
              </template>
              <template #cell(zoneId)="data">
                {{ idToName(data.value) }}
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type {
  Type1InternetAddress,
  Type1PrivateSite,
  Type1Zone,
} from "@/apis/Type1SiteApi";
import { defineComponent } from "vue";
import type { AppTableHeader } from "@/components/AppTable.vue";
import PrivateSiteModify from "@/modals/type1/PrivateSiteModify.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "PrivateSiteReference",
  props: {
    enumber: {
      type: String,
      required: true,
    },
    siteList: {
      type: Object as PropType<Type1PrivateSite>,
      required: true,
    },
    zoneList: {
      type: Array as PropType<Type1Zone[]>,
      required: true,
    },
    type1SiteZoneKeyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      privateData: {
        fields: [
          {
            key: "ipAddressName",
            title: "アドレス名",
          },
          {
            key: "ipAddress",
            title: "アドレス",
          },
          {
            key: "zoneId",
            title: "ゾーン配置",
          },
        ] as AppTableHeader<Type1InternetAddress>[],
        items: [] as Type1InternetAddress[],
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.privateData.items = this.siteList.addressList;
    },
    /** 変更機能 */
    async toChange() {
      await this.$modal.show(PrivateSiteModify, {
        enumber: this.enumber,
        siteList: this.siteList,
        zoneList: this.zoneList,
        type1SiteZoneKeyId: this.type1SiteZoneKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** IDからNameへ変換 */
    idToName(value: string | null) {
      return (
        this.zoneList.find((item) => item.zoneId === value)?.zoneName ??
        "未配置"
      );
    },
  },
});
</script>

<style lang="scss" scoped></style>
